import api from "../lib/axios";

// fetch site data
export const getSiteData = async (eventId) => {
  const res = await api.get(`/site/${eventId}`, {
    validateStatus: () => true, // allow handling non-200 manually
  });
  return res;
};

// create site (when not found)
export const createSite = async (eventId, token, data) => {
  console.log("Creating site with data:", data);
  const res = await api.post(
    `/site/${eventId}`,
    { data: data },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
  return res;
};

// update site data
export const updateSiteData = async (eventId, token, data) => {
  const res = await api.put(
    `/site/${eventId}`,
    { data: data },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
  return res;
};

// update site style
export const updateSiteStyle = async (eventId, token, data) => {
  const res = await api.put(
    `/site/${eventId}/style`,
    { data: data },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
  return res;
};

export const getHideData = async (eventId) => {
  const res = await api.get(`/site/navMenuData/${eventId}`, {
    validateStatus: () => true,
  });
  return res;
};

// site analytics
export const addSiteVisitAnalytics = async (eventId, page, siteId) => {
  const res = await api.post(
    `/site/${eventId}/analytics`,
    { eventId, page, siteId },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
  return res;
};

export const getUserAllTickets = async (eventId, submissionId = null) => {
  let url = `/site/${eventId}/ticket`;
  if (submissionId) {
    url += `?submission_id=${encodeURIComponent(submissionId)}`;
  }
  const res = await api.get(url, {
    headers: {
      "Content-Type": "application/json",
    },
    validateStatus: () => true,
  });
  return res;
};
